// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2Zs1x","unreadBadge":"styles_unreadBadge__2WGqo","modalContent":"styles_modalContent__4HW-3","modal":"styles_modal__3uBPv"};